import { render, staticRenderFns } from "./sms-verification.vue?vue&type=template&id=e8706f6c&scoped=true"
import script from "./sms-verification.vue?vue&type=script&lang=js"
export * from "./sms-verification.vue?vue&type=script&lang=js"
import style0 from "./sms-verification.vue?vue&type=style&index=0&id=e8706f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8706f6c",
  null
  
)

export default component.exports